<svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
<path fill="none" d="M5.5 8L10.5 13L15.5 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
</svg>
